import React, { useState } from 'react';
import HeroSlider from '../components/HeroSlider';
import StatsCounter from '../components/StatsCounter';
import Categories from '../components/Categories';
import AIChatbot from '../components/AIChatbot';
import './Home.css';

function Home() {
  const [showChatbot, setShowChatbot] = useState(false);

  return (
    <main>
      <HeroSlider />
      <StatsCounter />
      <Categories />
      
      <section id="services" className="section services-section">
        <div className="container">
          <h2 className="section-title">Γιατί να επιλέξετε το Freelancher;</h2>
          <p className="section-subtitle">
            Προσφέρουμε την καλύτερη εμπειρία για freelancers και πελάτες
          </p>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Γρήγορη Ανταπόκριση</h3>
              <p>Βρείτε τον κατάλληλο freelancer σε λίγα λεπτά</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">✅</div>
              <h3>Πιστοποιημένοι Επαγγελματίες</h3>
              <p>Όλοι οι freelancers είναι επαληθευμένοι</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Ανταγωνιστικές Τιμές</h3>
              <p>Λάβετε προσφορές από πολλούς επαγγελματίες</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>Ασφαλείς Συναλλαγές</h3>
              <p>Πληρώστε με ασφάλεια μέσω της πλατφόρμας</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Διαφανής Αξιολόγηση</h3>
              <p>Δείτε αξιολογήσεις από άλλους πελάτες</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🤝</div>
              <h3>24/7 Υποστήριξη</h3>
              <p>Η ομάδα μας είναι πάντα διαθέσιμη</p>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Έτοιμοι να ξεκινήσετε;</h2>
            <p>Βρείτε τον ιδανικό IT freelancer για το έργο σας σήμερα!</p>
            <div className="cta-buttons">
              <button className="btn btn-primary btn-large">
                Ξεκινήστε Τώρα
              </button>
              <button className="btn btn-outline btn-large">
                Μάθετε Περισσότερα
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* AI Chatbot Trigger Button */}
      {!showChatbot && (
        <button className="chatbot-trigger-btn" onClick={() => setShowChatbot(true)}>
          <div className="chatbot-trigger-icon">
            <div className="robot-avatar-trigger">
              <div className="robot-head-trigger">
                <div className="robot-eyes-trigger">
                  <div className="robot-eye-trigger"></div>
                  <div className="robot-eye-trigger"></div>
                </div>
              </div>
            </div>
          </div>
          <span className="chatbot-trigger-text">Χρειάζεστε βοήθεια;</span>
        </button>
      )}

      {/* AI Chatbot */}
      {showChatbot && <AIChatbot onClose={() => setShowChatbot(false)} />}
    </main>
  );
}

export default Home;
